// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__95tNq","type":"styles_type__iXrqM","choices":"styles_choices__18Fgi"};